import { createSelector } from 'reselect';

import { color } from 'app/shared/styles_js/variables';
import { formatSelectedMonth } from 'app/dealer/shared/utils/pure-functions/dates';

import { getLeadsBenchmarkReducer } from '../selectors';

/**
 * @description style getters
 */
export const getArrowIcon = leadsCountChange => {
  if (leadsCountChange > 0) {
    return { icon: 'arrow-up-short-long', iconColor: color.brandPrimary };
  }
  if (leadsCountChange < 0) {
    return { icon: 'arrow-down-short-long', iconColor: color.brandDangerAlt };
  }
  return { icon: 'arrow-right-long', iconColor: color.grayDark };
};

/**
 * @description all errors
 */
export const selectAllLeadsBenchmarkErrors = createSelector(
  [getLeadsBenchmarkReducer],
  ({ errors }) => errors,
);

/**
 * @description
 * error state for entire feature
 */

export const getFullErrorState = (state, action) => ({
  ...state,
  dataRequestLoading: false,
  errors: [
    ...state.errors,
    { [action.type]: action.error.message || action.error },
  ],
});

export const selectLeadsBenchmarkFirstDataRequestCompleted = createSelector(
  [getLeadsBenchmarkReducer],
  ({ firstDataRequestCompleted }) => firstDataRequestCompleted,
);

export const selectLeadsBenchmarkDataRequestLoading = createSelector(
  [getLeadsBenchmarkReducer],
  ({ dataRequestLoading }) => dataRequestLoading,
);

/**
 * @description
 * task cancellation
 */
export const selectLeadsBenchmarkDataRequestCancelled = createSelector(
  [getLeadsBenchmarkReducer],
  ({ dataRequestCancelled }) => dataRequestCancelled,
);

// #region date filters
export const selectLeadsBenchmarkSelectedMonth = createSelector(
  [getLeadsBenchmarkReducer],
  ({ selectedMonth }) => selectedMonth,
);

export const selectLeadsBenchmarkSelectedYear = createSelector(
  [getLeadsBenchmarkReducer],
  ({ selectedYear }) => selectedYear,
);

export const selectLeadsBenchmarkApiDate = createSelector(
  [selectLeadsBenchmarkSelectedMonth, selectLeadsBenchmarkSelectedYear],
  (month, year) => `${year}-${formatSelectedMonth(month)}`,
);

export const selectLeadsBenchmarkSelectedDate = createSelector(
  [getLeadsBenchmarkReducer],
  ({ selectedDate }) => new Date(selectedDate),
);
